import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  saveNumberRange,
  closeNumberRangeForm,
} from '../store/modules/numberrange';

import FormNumberRange from '../components/FormNumberRange/FormNumberRange';

const mapActionCreators = {
  saveNumberRange,
  closeNumberRangeForm,
};

const mapStateToProps = (state): {} => ({
  numberRange: state.numberRange.numberRanges[state.numberRange.formTarget],
  open: state.numberRange.formOpen,
  formTarget: state.numberRange.formTarget,
  user: state.login.user,
});

class NumberRangeFormContainer extends React.Component {
  render() {
    if (this.props.open === false) {
      return null;
    }

    return (
      <FormNumberRange
        numberRange={this.props.numberRange}
        saveNumberRange={this.props.saveNumberRange}
        closeNumberRangeForm={this.props.closeNumberRangeForm}
        push={this.props.push}
      />
    );
  }
}

NumberRangeFormContainer.propTypes = {
  saveNumberRange: PropTypes.func.isRequired,
  closeNumberRangeForm: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
  numberRange: PropTypes.object,
  open: PropTypes.bool,
  formTarget: PropTypes.oneOfType([
    // eslint-disable-line react/no-unused-prop-types
    PropTypes.object,
    PropTypes.string,
  ]),
};

export default connect(
  mapStateToProps,
  mapActionCreators,
)(NumberRangeFormContainer);



// WEBPACK FOOTER //
// ./src/containers/NumberRangeFormContainer.js